import { render } from "./BottomNavItem.vue?vue&type=template&id=6ec3f4d2&scoped=true"
import script from "./BottomNavItem.vue?vue&type=script&lang=js"
export * from "./BottomNavItem.vue?vue&type=script&lang=js"

import "./BottomNavItem.vue?vue&type=style&index=0&id=6ec3f4d2&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec3f4d2"]])

export default __exports__